import Exception from './Excception';

export default Exception;
